// @flow
import CafeteriaOrderRequests from './CafeteriaOrderRequests';

export default CafeteriaOrderRequests;
